import { Badge } from "@/components/ui";
/** Presentation of explicit existing response markers only; never infer facts from prose. */
export function answerSectionKind(line: string) {
  if (/^(Empfehlung:|Nächster Schritt:|Delegierbar \()/u.test(line)) return "EMPFEHLUNG";
  if (/^(Warnung:|Überfällig \(|Fristen & Risiken \()/u.test(line)) return "WARNUNG";
  if (/^(Entscheidung nötig \(|Entscheidung:)/u.test(line)) return "ENTSCHEIDUNG";
  if (/^(Fehlende Daten:)/u.test(line) || /^\[[^\]]+\] Datenstand: [^.]+\. Für diese Frage liegen in JARVIS keine belastbaren Daten vor\./u.test(line)) return "FEHLENDE DATEN";
  if (/^Berechnung:/u.test(line)) return "BERECHNUNG";
  if (/^Entwurf:/u.test(line)) return "ENTWURF";
  if (/^Fakt:/u.test(line)) return "FAKT";
  return null;
}
export function AssistantAnswer({ content }: { content: string }) {
  return <div className="assistant-answer">{content.split("\n").map((line, index) => {
    const kind = answerSectionKind(line);
    return <div key={index} className={kind ? "answer-section" : ""}>{kind && <Badge tone={kind === "WARNUNG" || kind === "ENTSCHEIDUNG" ? "amber" : kind === "FEHLENDE DATEN" ? "slate" : "sky"}>{kind}</Badge>}<p>{line || "\u00a0"}</p></div>;
  })}</div>;
}
